package team.platforma.chatdata.table

import kotlin.Long
import kotlin.String

public data class MokMessage(
  public val id: Long,
  public val chatId: Long,
  public val aiModelId: Long,
  public val userId: Long,
  public val textMessage: String,
  public val status: String,
  public val senderId: Long,
)
